module.exports = __webpack_public_path__ + "img/network.4bae17f8.png";